/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Voucher from "./Voucher";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import BackSections from "../Giftcards/BackSections";
import { decryptURLParam } from "../../Common/Axios/encrypt";
import { getValidDenominations } from "../Utility/Utility";

const LetShop3 = (arrayData) => {
  const location = useLocation();
  const modalData = location.state?.moduleData;
  const [enhancedProductReducer, setEnhancedProductReducer] = useState(null);
  const productData = useSelector((state) => state?.productDataReducer?.data)

  const priceDenomination = getValidDenominations(productData?.clientProductDenomination);
  useEffect(() => {
    if (productData) {
      setEnhancedProductReducer({
        ...productData,
        priceDenomination: priceDenomination,
      })
    }
  }, [productData]);

  // Conditionally decrypt the productId from URL based on environment setting
  const encryptedProductId = new URLSearchParams(window.location.search).get("productId");
  const url = encryptedProductId
    ? (process.env.REACT_APP_IS_E_E === 'false'
      ? encryptedProductId
      : decryptURLParam(encryptedProductId))
    : null;

  // useEffect(() => {
  //   dispatch(onProductByProductIdSubmit(url));
  // }, [url]);

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className={`checkoutSection letshop3 ${!isMobileView ? "bg" : ""} `}>
      <ScrollToTop />
      <BackSections />
      <div className="container">
        <div className="flex-container">
          <div className="voucher-section">
            <Voucher
              productReducer={productData}
              productReducerDisocount={enhancedProductReducer}
              arrayData={arrayData}
              modalProductData={modalData}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LetShop3;
